import { useCallback } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { AiAssistantMainMenuTileItemRecordAgainModal } from './AiAssistantMainMenuTileItemRecordAgainModal';

type AiAssistantMainMenuTileItemRecordAgainModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type AiAssistantMainMenuTileItemRecordAgainModalOpenerProps = {
   children: (renderProps: AiAssistantMainMenuTileItemRecordAgainModalOpenerRenderProps) => JSX.Element;
   onConfirm: VoidFunction;
};

export const AiAssistantMainMenuTileItemRecordAgainModalOpener = (
   props: AiAssistantMainMenuTileItemRecordAgainModalOpenerProps
): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   const handleConfirm = useCallback(() => {
      closeModal();
      props.onConfirm();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [closeModal, props.onConfirm]);

   return (
      <>
         {props.children({ openModal: openModal })}

         {modalOpened ? (
            <AiAssistantMainMenuTileItemRecordAgainModal onConfirm={handleConfirm} onClose={closeModal} />
         ) : null}
      </>
   );
};
